import smslogin from '../../api/smslogin';

function initialState() {
  return {
    smsCodeSent: false,
    smsCode: '',
    actors: null,
    actorId: null,
    selectedActor: null,
    placeOfConsumption: null,
    deliveryPoint: {
      numberOfPhases: null,
      consumptionPreviousYear: null,
    },
    errorMessage: '',
    isSmsLoginModalVisible: false,
  };
}

const state = initialState();

const mutations = {
  setSmsCodeSent(state, payload) {
    state.smsCodeSent = payload;
  },
  setSmsCode(state, payload) {
    state.smsCode = payload;
  },
  setActors(state, payload) {
    state.actors = payload;
  },
  setActorId(state, payload) {
    state.actorId = payload;
  },
  setSelectedActor(state, payload) {
    state.selectedActor = payload;
  },
  setDeliveryPoint(state, payload) {
    const numberOfPhases =
      (payload &&
        payload.technicalDataEL &&
        payload.technicalDataEL.numberOfPhases) ||
      null;

    // If previous year consumption is available, calculate total and save with delivery point
    const consumptionPreviousYear =
      (payload &&
        payload.previousYear &&
        payload.previousYear.reduce((previous, current) => {
          return (previous += current.consumption);
        }, 0)) ||
      null;

    state.deliveryPoint = {
      ...payload,
      numberOfPhases,
      consumptionPreviousYear,
    };
  },
  setPlaceOfConsumption(state, payload) {
    state.placeOfConsumption = payload;
  },
  setErrorMessage(state, payload) {
    state.errorMessage = payload;
  },
  setSmsLoginModalVisibility(state, payload) {
    state.isSmsLoginModalVisible = payload;
  },
};

const actions = {
  resetSmsLogin({ commit }) {
    commit('setDeliveryPoint', initialState().deliveryPoint);
    commit('setPlaceOfConsumption', initialState().placeOfConsumption);
    commit('setErrorMessage', initialState().errorMessage);
    commit('setSelectedActor', initialState().selectedActor);
  },

  getLoginCode({ commit, rootState }) {
    commit('setIsLoading', true, { root: true });
    commit('setLoadingText', 'Sender engangskode på SMS...', { root: true });

    smslogin.requestSmsLoginCode(
      rootState.CustomerInformation.phoneNumber,
      // Callback when api call is completed
      success => {
        commit('setIsLoading', false, { root: true });
        if (success) {
          commit('setErrorMessage', '');
          commit('setSmsCodeSent', true);
        } else {
          commit(
            'setErrorMessage',
            'Noe gikk galt med utsending av SMS. Prøv igjen senere.'
          );
        }
      }
    );
  },

  getActors({ state, commit, dispatch, rootState }) {
    commit('setIsLoading', true, { root: true });
    commit('setLoadingText', 'Henter informasjon om kundeforhold...', {
      root: true,
    });

    smslogin.fetchActorsBySmsCode(
      state.smsCode,
      rootState.CustomerInformation.phoneNumber,
      actors => {
        commit('setIsLoading', false, { root: true });
        commit('setActors', actors);
        commit('setErrorMessage', '');
        if (actors && actors.length === 1) {
          commit('setActorId', actors[0].id);
          dispatch('getActor');
        }
      },
      () => {
        commit('setIsLoading', false, { root: true });
        commit(
          'setErrorMessage',
          'Noe gikk galt under lasting av kundedata. Prøv igjen senere.'
        );
      }
    );
  },

  getActor({ state, commit, dispatch }) {
    commit('setIsLoading', true, { root: true });
    commit('setLoadingText', 'Henter informasjon om kundeforhold...', {
      root: true,
    });

    smslogin.fetchActor(
      state.actorId,
      actor => {
        commit('setIsLoading', false, { root: true });
        commit('setErrorMessage', '');
        commit('setSelectedActor', actor);

        commit(
          'setCustomerInformation',
          {
            CustomerInformation: {
              fullName: `${actor.firstName || ''} ${actor.lastName || ''}`,
              phoneNumber: actor.cellularPhoneNumber,
              email: actor.emailAddress,
              postalCode: actor.zipCode,
              postalArea: actor.city,
              birthdate: actor.dateOfBirth,
            },
          },
          { root: true }
        );

        if (
          actor.placesOfConsumption &&
          actor.placesOfConsumption.length === 1
        ) {
          commit('setPlaceOfConsumption', actor.placesOfConsumption[0]);
          dispatch('setDeliveryPoint');
        }
      },
      () => {
        commit(
          'setErrorMessage',
          'Noe gikk galt under lasting av kundedata. Prøv igjen senere.'
        );
        commit('setIsLoading', false, { root: true });
      }
    );
  },
  setDeliveryPoint({ state, commit }) {
    if (state.placeOfConsumption && state.placeOfConsumption.deliveryPoints) {
      // Find deliverypoint of type Consumption to use for further calculation
      const deliveryPoint = state.placeOfConsumption.deliveryPoints.find(
        deliveryPoint => deliveryPoint.type === 'Consumption'
      );

      if (deliveryPoint) {
        commit('setDeliveryPoint', deliveryPoint);
      }
    }
  },
  showSmsLoginModal({ dispatch, commit }) {
    dispatch('resetSmsLogin');
    commit('setSmsLoginModalVisibility', true);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
